import React from "react";
import "./notAuthorized.css";
import botImage from "../../assets/img/robot-black.png"; // Substitua pelo caminho correto da sua imagem

const ChatbotMessage = () => {
    return (
        <div className="chatbotContainer">
            <div className="chatbotImage">
                <img src={botImage} alt="Chatbot" id="chatbotImage" />
            </div>
            <div className="messageBubble">
                <p>
                    Olá, você não está autenticado! <br />
                    Faça seu{" "}
                    <a href="https://acesso-app.cmd-automacao.com/" className="loginText">Login</a>
                </p>
            </div>
        </div>
    );
};

export default ChatbotMessage;
